import { Inject, Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpInterceptor } from '@angular/common/http';
import { AuthenticationService } from './authentication.service';
import { filter, map, mergeMap, tap } from 'rxjs/operators';
import { Configurations } from '../configurations/models/configurations.model';
import { APP_CONFIG } from '../configurations/configurations.factory';
import { PortoAuthenticationService } from './porto-authentication.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  public constructor(@Inject(APP_CONFIG) private config: Configurations,
    private readonly auth: AuthenticationService,
    private readonly portoAuth: PortoAuthenticationService) {
  }

  public intercept(request: HttpRequest<any>, next: HttpHandler) {

    if (this.isAuthRequest(request)) return next.handle(request)

    else if (this.isLobbyEndpoint(request)) return this.authorizeAsLobby(request).pipe(mergeMap(authorizedRequest => next.handle(authorizedRequest)))
    else if (this.isPortoEndpoint(request)) return this.authorizeAsPorto(request).pipe(mergeMap(authorizedRequest => next.handle(authorizedRequest)))

    else return next.handle(request);
  }

  isAuthRequest(request: HttpRequest<any>) {
    return request.url.toLowerCase().endsWith('login') // da sistemare
  }

  private isLobbyEndpoint(request: HttpRequest<any>) {
    return request.url.toLowerCase().startsWith(this.config.environmentConfig.lobbyBaseUrl.toLowerCase())
  }

  private isPortoEndpoint(request: HttpRequest<any>) {
    //console.log('is porto', request.url.toLowerCase().startsWith(this.config.environmentConfig.portoSecureApiBaseUrl.toLowerCase()))
    return request.url.toLowerCase().startsWith(this.config.environmentConfig.portoSecureApiBaseUrl.toLowerCase())
  }

  private authorizeAsLobby(request: HttpRequest<any>) {
    return this.auth.getAccessToken().pipe(map(token => request.clone({ setHeaders: { Authorization: `Bearer ${token}` } })));
  }

  private authorizeAsPorto(request: HttpRequest<any>) {
    return this.portoAuth.getAccessToken$().pipe(map(token => request.clone({ setHeaders: { Authorization: `Bearer ${token}` } })));
  }
}
